import DateTimeService from '@app/Services/DateTimeService';
import { RosterCell } from '@app/Models';

export class TitleService {
    public buildTitle(baseTitle: string, selectedList: RosterCell[]) {
        const startDate: Date = selectedList[0].date;
        const personCodes: string[] = [];
        let isSameDate: boolean = true;

        selectedList.forEach((personDay) => {
            if (isSameDate) {
                isSameDate = DateTimeService.isSameDate(startDate, personDay.date);
            }

            if (personCodes.findIndex((c) => c === personDay.person.code) === -1) {
                personCodes.push(personDay.person.code);
            }
        });

        let isSameRange: boolean = true;
        let minDate: Date | null = null;
        let maxDate: Date | null = null;
        personCodes.forEach((code) => {
            const dates = selectedList
                .filter((p) => p.person.code === code)
                .map((p) => p.date.getTime())
                .sort()
                .map((d) => new Date(d));
            if (isSameRange) {
                const isEqualStartEnd = minDate && maxDate ? DateTimeService.isSameDate(minDate, dates[0]) && DateTimeService.isSameDate(maxDate, dates[dates.length - 1]) : true;
                minDate = dates[0];
                maxDate = dates[dates.length - 1];
                isSameRange = isEqualStartEnd && dates.length === DateTimeService.diffDays(maxDate, minDate) + 1;
            }
        });

        const dateTitle = isSameDate ? DateTimeService.toUiDate(startDate) : isSameRange ? `${minDate && DateTimeService.toUiDate(minDate)} - ${maxDate && DateTimeService.toUiDate(maxDate)}` : `selection`;
        const personTitle = personCodes.slice(0, 5).join(', ') + (personCodes.length > 5 ? ` and ${personCodes.length - 5} more` : '');
        return `${baseTitle} / ${personTitle} for ${dateTitle}`;
    }
}
